module.exports = __webpack_public_path__ + "img/inclusion.6a6f0105.svg";